import { jsonProperty, Serializable } from 'ts-serializable';

// Модель ответа для отправки на бэк
export class SurveyResultDto extends Serializable {
  @jsonProperty(Number, null) questionId: number | null = null;
  @jsonProperty(Number, null) answerId: number | null = null;
  @jsonProperty(Number, null) happyIndex: number | null = null;
  @jsonProperty(String, null) textValue: string | null = null;
}
